<!--
 * @Author: tp
 * @Date: 2021-07-13 10:22:11
 * @Description: 物流出库单 LogisticsDeliveryOrderList
 -->
<template>
  <div v-loading.fullscreen="loading" class="list" element-loading-text="加载中">
    <el-card>
      <condition-search ref="search" :query-items="queryItems" :search-param="searchParam" @search="search"
        @reset="reset">
      </condition-search>
    </el-card>
    <el-card>
      <!-- 任务列表 -->
      <el-table ref="table1" border :data="pageListData" :height="heightStyleObj" style="width:100%;margin-top: 10px">
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="单据创建日期">
          <template slot-scope="{row}">
            {{ row.bizCreateDate ? parseTime(row.bizCreateDate) : null }}
          </template>
        </el-table-column>
        <el-table-column width="140px" show-overflow-tooltip prop="bizId" label="单据编号" />
        <el-table-column show-overflow-tooltip prop="bizType" label="业务类型">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.bizType" :value="scope.row.bizType" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="udiCode" label="UDI码" />
        <el-table-column show-overflow-tooltip prop="goodsCode" label="物料编码" />
        <el-table-column show-overflow-tooltip prop="batchNumber" label="批号" />
        <el-table-column show-overflow-tooltip label="验货时间">
          <template slot-scope="{row}">
            {{ row.inspectionDate ? parseTime(row.inspectionDate) : null }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="inspectorName" label="验货人名称" />
        <el-table-column show-overflow-tooltip label="验货状态">
          已验货
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
  </div>
</template>

<script>
import { getInspectedList } from '@/api/orderManage'
import { getDict } from '@/api/common'

export default {
  data() {
    return {
      // 生产任务列表数据
      pageListData: [],
      loading: false,
      searchParam: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchValue',
          placeholder: '单据编号/UDI码/物料编码/批号',
          width: '300px',
          type: 'input'
        },
        {
          label: '单据创建时间',
          field: 'createDate',
          type: 'date'
        },
        {
          label: '验货时间',
          field: 'specifyDeliveryDate',
          type: 'date'
        },
      ],
      dictObj: {
        bizType: [],
      },
      heightStyleObj: ''
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()
    this.getDicts(['bizType'])

  },
  methods: {
    // 查询
    search() {
      this.searchParam.pageNum = 1;
      this.getPageListData()
    },
    // 重置
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    // 获取出库单列表数据
    getPageListData() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.searchParam))
      if (params.specifyDeliveryDate) {
        const [inspectionStartDate, inspectionEndDate] = params.specifyDeliveryDate
        params.inspectionStartDate = inspectionStartDate
        params.inspectionEndDate = inspectionEndDate
        delete params.specifyDeliveryDate
      }
      if (params.createDate) {
        const [startDate, endDate] = params.createDate
        params.startDate = startDate
        params.endDate = endDate
        delete params.createDate
      }
      getInspectedList(params).then(res => {
        this.pageListData = res.rows
        this.searchParam.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

  }
}

</script>
